<div class="row" [formGroup]="formGroup">
    <div class="col-lg-12">
        <!-- <h5 class="title-step" align="center" *ngIf="showTitleAndCard">
            <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos cliente
        </h5> -->

        <h5 class="title-step" align="center" *ngIf="showTitleAndCard">
            <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos personales
        </h5>
        <div [ngClass]="{'card' : showTitleAndCard}">
            <ul class="list-group list-group-flush">
                <li class="list-group-item cuerpo-pack">
                    <div class="form-row row">

                        <div class="mt-1" [ngClass]="{'col-lg-2' : showTitleAndCard, 'col-lg-3' : !showTitleAndCard}">
                            <mat-form-field>
                                <mat-label>Tipo documento</mat-label>

                                <select matNativeControl required formControlName="doctype"
                                        (change)="changeTypeDocument($event.target.value); setMaxLengthByDoc($event.target.value)">
                                    <option *ngFor="let documentType of documentTypes" value="{{ documentType.digo_code }}">
                                        {{ documentType.digo_code }}
                                    </option>
                                    <option *ngIf="requestCompanyInfo">CIF</option>
                                </select>
                            </mat-form-field>
                        </div>

                        <div class="mt-1" [ngClass]="{'col-lg-2' : showTitleAndCard, 'col-lg-3' : !showTitleAndCard}">
                            <mat-form-field>
                                <mat-label>Nº de documento</mat-label>
                                <input matInput type="text" name="doc" formControlName="doc" [maxLength]="maxLengthByDoc" (input)="formGroup.get('doc').patchValue(formGroup.get('doc').value.toUpperCase())" required>
                                <!-- error -->
                                <mat-error *ngIf="formGroup.get('doc')?.errors?.required">
                                    Campo obligatorio.
                                </mat-error>
                                <mat-error *ngIf="formGroup.get('doc')?.errors?.doc && !formGroup.get('doc')?.errors?.required">
                                    Número de documento erróneo
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="mt-1" [ngClass]="{'col-lg-2' : showTitleAndCard, 'col-lg-3' : !showTitleAndCard}">
                            <mat-form-field>
                                <mat-label>Nacionalidad</mat-label>
                                <select matNativeControl required formControlName="country"
                                        [(ngModel)]="selectedCountry">
                                    <ng-container *ngFor="let country of countries;">
                                        <option [value]="country.code" *ngIf="!(formGroup.get('doctype').value === 'NIE' && country.code === 'Spain')">
                                            {{ country.description }}
                                        </option>
                                    </ng-container>
                                </select>
                            </mat-form-field>
                        </div>

                        <div class="mt-1" [ngClass]="{'col-lg-2' : showTitleAndCard, 'col-lg-3' : !showTitleAndCard}">
                            <mat-form-field>
                                <mat-label>Nombre</mat-label>
                                <input matInput type="text" oninvalid="" required formControlName="firstName">
                            </mat-form-field>
                        </div>

                        <div class="mt-1" [ngClass]="{'col-lg-2' : showTitleAndCard, 'col-lg-3' : !showTitleAndCard}">
                            <mat-form-field>
                                <mat-label>Apellido1</mat-label>
                                <input matInput type="text" oninvalid="" required formControlName="surname1">
                            </mat-form-field>
                        </div>

                        <div class="mt-1" [ngClass]="{'col-lg-2' : showTitleAndCard, 'col-lg-3' : !showTitleAndCard}">
                            <mat-form-field>
                                <mat-label>Apellido2</mat-label>
                                <input matInput type="text" oninvalid="" formControlName="surname2">
                            </mat-form-field>
                        </div>

                        <div class="mt-1" [ngClass]="{'col-lg-2' : showTitleAndCard, 'col-lg-3' : !showTitleAndCard}">
                            <mat-form-field>
                                <mat-label>Fecha de nacimiento</mat-label>
                                <input matInput [matDatepicker]="picker" [max]="maxDate" [min]="minDate" required formControlName="birthday">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="mt-1" [ngClass]="{'col-lg-2' : showTitleAndCard, 'col-lg-3' : !showTitleAndCard}">
                            <mat-form-field>
                                <mat-label>Sexo</mat-label>
                                <select matNativeControl required formControlName="sex" [ngModel]="selectedSex">
                                    <option value="M">Masculino</option>
                                    <option value="F">Femenino</option>
                                </select>
                            </mat-form-field>
                        </div>

                        <!-- Este campo aparece si se elige CIF -->

                        <div class="mt-1" *ngIf="requestCompanyInfo && requireCif"
                                [ngClass]="{'col-lg-4' : showTitleAndCard, 'col-lg-3' : !showTitleAndCard}">
                            <mat-form-field>
                                <mat-label>Razón social</mat-label>
                                <input matInput type="text" oninvalid="" formControlName="company">
                            </mat-form-field>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <h5 class="title-step mt-4" align="center" *ngIf="showTitleAndCard">
            <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos de contacto
        </h5>
        <div [ngClass]="{'card' : showTitleAndCard}">
            <ul class="list-group list-group-flush">
                <li class="list-group-item cuerpo-pack">
                    <div class="form-row">
                        <!-- <div class="col-lg-3 mb-1">
                            <mat-form-field>
                                <mat-label>Tipo de vía</mat-label>
                                <select matNativeControl formControlName="tipoVia" required>
                                    <option *ngFor='let datos of datosTipoVia' value="{{datos.code}}">{{datos.code}}</option>
                                </select>
                                <mat-error>
                                    Campo obligatorio.
                                </mat-error>
                            </mat-form-field>
                        </div> -->

                        <div class="col-lg-6 mb-1">
                            <mat-form-field>
                                <mat-label>Nombre de la vía</mat-label>
                                <input matInput matGoogleMapsAutocomplete required type="text" name="nombreVia" formControlName="nombreVia"
                                    [types]="['address']"
                                    [country]="country"
                                    (onAutocompleteSelected)="onAutocompleteSelected($event)">
                                <!-- error -->
                                <mat-error>
                                    Campo obligatorio.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-1 mb-1">
                            <mat-form-field>
                                <mat-label>Número</mat-label>
                                <input matInput type="number" name="numero" formControlName="numero" required pattern="\d+" min="0">
                                <!-- error -->
                                <mat-error>
                                    Campo obligatorio.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-2 mb-1">
                            <mat-form-field>
                                <mat-label>Planta</mat-label>
                                <input type="text" matInput formControlName="planta" [matAutocomplete]="autoFloorTypes">
                                <mat-autocomplete #autoFloorTypes="matAutocomplete" [panelWidth]="200">
                                    <mat-option *ngFor="let option of floorFilteredOptions | async" [value]="option.code">
                                        {{ option.description }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-1 mb-1">
                            <mat-form-field>
                                <mat-label>Puerta</mat-label>
                                <input type="text" matInput formControlName="puerta" maxlength="4">
                            </mat-form-field>
                        </div>

                        <div class="col-lg-2 mb-1">
                            <mat-form-field>
                                <mat-label>Escalera</mat-label>
                                <input type="text" matInput formControlName="escalera" [matAutocomplete]="autoStaircaseTypes">
                                <mat-autocomplete #autoStaircaseTypes="matAutocomplete" [panelWidth]="200">
                                    <mat-option *ngFor="let option of staircaseFilteredOptions | async" [value]="option.code">
                                        {{ option.description }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>

                    <!--SEGUNDA FILA-->
                    <div class="form-row">
                        <div class="col-lg-3 mb-1">
                            <mat-form-field>
                                <mat-label>Código Postal</mat-label>
                                <input matInput type="number" name="codigoPostal" formControlName="codigoPostal" required (input)="onChangeZip($event.target.value)" pattern="\d+" min="0">
                                <!-- error -->
                                <mat-error>
                                    Campo obligatorio.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-5 mb-1">
                            <mat-form-field>
                                <mat-label>Localidad</mat-label>
                                <input matInput type="text" name="localidad" formControlName="localidad" required>
                                <!-- error -->
                                <mat-error>
                                    Campo obligatorio.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-4 mb-1">
                            <mat-form-field>
                                <mat-label>Provincia</mat-label>
                                <select matNativeControl formControlName="provincia" required>
                                    <option *ngFor="let datos of datosProvincia" value="{{datos.code}}">{{datos.code}}</option>
                                </select>
                                <!-- error -->
                                <mat-error>
                                    Campo obligatorio.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-lg-2 mt-1">
                            <div class="form-group">
                                <mat-form-field>
                                    <mat-label>Teléfono de contacto</mat-label>
                                    <input matInput type="text" oninvalid="" required formControlName="phone" maxlength="9">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="col-lg-4 mt-1">
                            <div class="form-group">
                                <mat-form-field>
                                    <mat-label>Correo electrónico</mat-label>
                                    <input matInput type="text" oninvalid="" required formControlName="email">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="col-lg-4 mt-1">
                            <div class="form-group">
                                <mat-form-field>
                                    <mat-label>Confirmar correo electrónico</mat-label>
                                    <input matInput type="text" oninvalid="" required formControlName="email_confirm">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div *ngIf="showTitleAndCard && pdv && pdv.permissions.AMENA_VENTA_DE_TERMINALES === 'PERMITE_LA_VENTA_DE_TERMINALES' && showDelivery">
            <h5 class="title-step mt-4" align="center">
                <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Método de entrega
            </h5>
            <div [ngClass]="{'card' : showTitleAndCard}">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item cuerpo-pack">
                        <div class="form-row">
                            <div class="col-lg-7 mb-0">
                                <app-terminal-delivery #terminalDelivery [listener]="this" [userForm]="formGroup"></app-terminal-delivery>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div align="center" *ngIf="!showTitleAndCard">
            <button class="btn btn-green btn-sm mb-0" (click)="validateForm()">Guardar</button>
        </div>

        <h5 class="title-step mt-4" align="center" *ngIf="showBankingData">
            <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos bancarios
        </h5>
        <div [ngClass]="{'card' : showTitleAndCard}" *ngIf="showBankingData">
            <ul class="list-group list-group-flush">
                <li class="list-group-item cuerpo-pack">
                    <app-user-banking-data id="userBankingData" #userBankingData
                        [listener]="this"
                        [countries]="countries"
                        [model]="model.bankingData"
                        [requestCompanyInfo]="requestCompanyInfo"
                        [userForm]="formGroup">
                    </app-user-banking-data>
                </li>
            </ul>
        </div>
    </div>
</div>

